import React from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import TableOnSteroids from '../../../../frontend/components/components/utils/TableOnSteroids';
import configureStore from '../../../../frontend/components/store/configureStore';
import ComponentMap, { DEFAULT_COLUMNS } from './TableOnSteroidsComponentMap';

const store = configureStore();


const Tables = () => {
  const { t } = useTranslation();

  return (
    <div className="styles-section row" id="tables">
      <div className='main-page-title col-12'>
        <h3>Tables</h3>
      </div>
      <div className='home-page-content col-12'>
        <Provider store={store}>
          <Router >
            <TableOnSteroids
              tableId="knowledgeNew"
              objectsUrl="/api/v1/influencers/influencers/featured_offers"
              objectType="offers"
              componentMap={ComponentMap}
              defaultColumns={DEFAULT_COLUMNS}
              title={t('influencers.featured_offers')}
              hideFilters={true}
              hideSearch={true}
              styleVersion='v4'
              className='knowledge-table-example'
            />
          </Router>
        </Provider>
      </div>
    </div>
  );
};

export default Tables;
